var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg10":"","offset-lg1":""}},[_c('formFiltro'),_c('facturasPendientes'),(_vm.$store.state.appconfig.autoventa)?_c('buttonLaunchReport'):_vm._e()],1),_c('dialogTipoCobro'),(_vm.$store.state.appconfig.autoventa)?_c('dialogInformeComerciales'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }